import React, { useEffect, useState, useRef } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  useExamReportMutation,
  useExamDetailsMutation,
  useStudentExamStatusMutation,
  useAdvanceReportMutation,
  useExamStatusMutation,
  useWebEngageMutation,
  useDeviceDetailsLSQMutation
} from "../store/ApiMutaion";
import AdvanceReport from "./components/AdvanceReport";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedEventsDetails, getToken, getDeviceAndLocation } from "../store/auth/selectors";
import { format, parseISO } from "date-fns";
import { CONFIG_VARS } from "../constants/configuration";
import BasicReport from "./components/BasicReport";
import { Timer } from "./components/Timer";
import { userLogout } from "../store/auth/auth.slice";
import { ROUTES } from "../constants/routes";
import { setModalState } from "../store/app/app.slice";
import { ReloginPopUp } from "./components/modal/ReloginPopup";
import PiPVideoPlayer from "./components/PipVideoPlayer";
import { ExamConfigHelper } from "../constants/examConfig";
import { reportsPageStickyBannerConfig } from "../configs/stickyBanner/reportsPageConfig";
import { TalkToExpertModal } from "./components/modal/TalkToExpertModal";
import { useAnalytics } from "../contexts/AnalyticsContext";

export const Reports = () => {
  const { examId } = useParams();
  const history = useHistory();
  const [reportData, setReportData] = useState([]);
  const [progressordata, setProgressordata] = useState({});
  const [examDetails, setExamDetails] = useState([]);
  const [condition, setCondition] = useState("timer");
  const [timeLeft, setTimeLeft] = useState(7200);
  const [timeLeft24, setTimeLeft24] = useState(86400);
  const [timeLeft72, setTimeLeft72] = useState(259200);
  const [reportLoader, setReportLoader] = useState(true);
  const [advanceReport, setAdvanceReport] = useState([]);
  const [advanced, setAdvanced] = useState(false);
  const [fetchExamReport] = useExamReportMutation();
  const [fetchExamDetails] = useExamDetailsMutation();
  const [updateStatus] = useStudentExamStatusMutation();
  const [fetchAdvancereport] = useAdvanceReportMutation();
  const [webEngage] = useWebEngageMutation();
  const [sendDeviceDetails] = useDeviceDetailsLSQMutation();
  const [formetDate, setFormetData] = useState();
  const [hasFetched, setHasFetched] = useState(false);
  const [webEngageSubmittedAt, setWebEngageSubmittedAt] = useState(null); // New state for WebEngage
  const examdetailes = useSelector(getSelectedEventsDetails);
  const deviceDetials = useSelector(getDeviceAndLocation);
  const [fetchExamStatus] = useExamStatusMutation();
  const currentExam = examdetailes?.title?.toLowerCase().replace(/[\s\W]+/g, "");
  const [showTalkToExpert, setShowTalkToExpert] = useState(false);
  const [talkToExpertSource, setTalkToExpertSource] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const isBooked = examdetailes?.is_demo_booked;
  const analytics = useAnalytics();

  const pollAttemptRef = useRef(0);
  const webEngageRetryRef = useRef(0);
  const maxWebEngageRetries = 3;

  const reportConfig = ExamConfigHelper.getReportConfig(examdetailes?.title);
  const shouldShowTimer = ExamConfigHelper.shouldShowTimer(examdetailes?.title);
  const shouldShowAdvanceReport = ExamConfigHelper.shouldShowAdvanceReport(examdetailes?.title);
  const hasExternalAdvanceReport = ExamConfigHelper.hasExternalAdvanceReport(examdetailes?.title);
  const externalReportRoute = ExamConfigHelper.getExternalReportRoute(examdetailes?.title);
  const shouldShowTalkToExpert = ExamConfigHelper.shouldShowTalkToExpert(examdetailes?.title);
  const showPIP = ExamConfigHelper.showPIP(examdetailes?.title);

  const [showBuyReportBanner, setShowBuyReportBanner] = useState(false);

  useEffect(() => {
    const fetchRedirectUrl = async () => {
      try {
        const response = await fetch(`${CONFIG_VARS.pip_GCS_url}/pip-videos/redirects.json`, {
          method: "GET",
          mode: "cors"
        });
        const data = await response.json();
        setRedirectUrl(data[`Grade-${examdetailes.grade_id}`] || "");
      } catch (err) {
        console.error("Failed to fetch redirect URL:", err);
      }
    };

    fetchRedirectUrl();
  }, [examdetailes]);

  const dispatch = useDispatch();

  const openPopup = () => setIsPopupOpen(true);
  const openpdf = () => setIsPdfPop(true);

  const openTalkToExpert = (source) => {
    setTalkToExpertSource(source);
    setShowTalkToExpert(true);
  };

  const handleSendDeviceDetailsLSQ = async (examId, eventId) => {
    try {
      const date = new Date();
      const formattedDate = date.toISOString().slice(0, 19).replace("T", " ");

      const payload = {
        activity_time: formattedDate
      };

      if (!deviceDetials) {
        return;
      }
      payload.latitude = deviceDetials.latitude;
      payload.longitude = deviceDetials.longitude;
      payload.ip_address = deviceDetials.ip_address;
      payload.platform = deviceDetials.webType.toLowerCase();

      await sendDeviceDetails({ examId, eventId, payload }).unwrap();
    } catch (err) {
      console.log(`Attempt failed: ${err.message}`);
    }
  };

  const handleFetchExamReport = async (examId, retryCount = 0) => {
    try {
      const data = await fetchExamReport(examId);
      if (data?.data?.error?.message === "UnAuthorized") {
        handleUnauthorized();
        return;
      }
      setReportData(data.data);
      setProgressordata(data.data.section_wise_marks);
      setReportLoader(false);
    } catch (error) {
      if (retryCount < 3) {
        setTimeout(() => {
          handleFetchExamReport(examId, retryCount + 1);
        }, 1000);
      } else {
        console.log("Max retry attempts reached. Could not fetch the exam report.");
      }
    }
  };

  const handleFetchExamdetials = async (examId) => {
    try {
      const data = await fetchExamDetails(examId);
      if (data?.data?.error?.message === "UnAuthorized") {
        handleUnauthorized();
        return;
      }
      setExamDetails(data.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  // New function to fetch submitted_at specifically for WebEngage with retry logic
  const fetchSubmittedAtForWebEngage = async () => {
    if (!examdetailes?.event_id) return;

    try {
      console.log(
        `[WebEngage] Attempt ${webEngageRetryRef.current + 1}/${maxWebEngageRetries} - Fetching submitted_at...`
      );

      const statusResponse = await fetchExamStatus(examId);

      if (statusResponse?.error || statusResponse?.data?.error) {
        throw new Error(statusResponse?.error?.message || statusResponse?.data?.error?.message || "API call failed");
      }

      const submittedAtTime = statusResponse?.data?.submitted_at;

      if (!submittedAtTime) {
        throw new Error("No submitted_at in response");
      }

      // Success - set the submitted_at for WebEngage
      console.log("[WebEngage] Successfully fetched submitted_at:", submittedAtTime);
      setWebEngageSubmittedAt(submittedAtTime);
    } catch (error) {
      console.error(`[WebEngage] Attempt ${webEngageRetryRef.current + 1} failed:`, error.message);

      if (webEngageRetryRef.current < maxWebEngageRetries - 1) {
        webEngageRetryRef.current += 1;
        const delay = Math.pow(2, webEngageRetryRef.current) * 1000;
        console.log(`[WebEngage] Retrying in ${delay / 1000} seconds...`);
        setTimeout(() => {
          fetchSubmittedAtForWebEngage();
        }, delay);
      } else {
        console.log("[WebEngage] ✗ Max retries reached. Could not fetch submitted_at.");
      }
    }
  };

  const handleUnauthorized = () => {
    history.push(ROUTES.STUDENT);
    dispatch(userLogout());
    dispatch(setModalState({ content: <ReloginPopUp />, open: true }));
  };

  const handleFetchExamStatus = async (examId, currentExam) => {
    pollAttemptRef.current = pollAttemptRef.current + 1;
    const currentAttempt = pollAttemptRef.current;

    try {
      let submittedAt;
      const isCurrentEventOffline = examdetailes.event_type === "OFFLINE";

      if (examdetailes.submitedAt) {
        const utcDate = parseISO(examdetailes.submitedAt);
        submittedAt = new Date(utcDate.getTime() + 5.5 * 60 * 60 * 1000 - 48 * 1000);
      } else {
        const statusResponse = await fetchExamStatus(examId);
        if (statusResponse?.error || statusResponse?.data?.error) {
          const httpStatus = statusResponse?.error?.status || statusResponse?.data?.statusCode || 500;
          analytics.trackReportStatusApiFailed(httpStatus, currentAttempt);
          throw new Error("Failed to fetch exam status");
        }
        submittedAt = parseISO(statusResponse.data.submitted_at);
      }
      setFormetData(format(submittedAt, "dd MMMM yyyy"));

      const timeDifference = Math.floor((new Date() - submittedAt) / 1000);

      if (isCurrentEventOffline) {
        const initialTimeLeft = Math.max(7200 - timeDifference, 0);
        setTimeLeft(initialTimeLeft);
        const offlineTimeLeft = Math.max(259200 - timeDifference, 0);
        setTimeLeft72(offlineTimeLeft);
      } else {
        const initialTimeLeft = Math.max(7200 - timeDifference, 0);
        setTimeLeft(initialTimeLeft);
        const PRInititalTimeleft = Math.max(86400 - timeDifference, 0);
        setTimeLeft24(PRInititalTimeleft);
      }
    } catch (error) {
      console.error("Error fetching exam status:", error.message);
      if (error.message !== "Failed to fetch exam status") {
        analytics.trackReportStatusApiFailed(500, currentAttempt);
      }
    }
  };

  const handleUpdateExamStatus = async (event_id, retryCount = 0) => {
    try {
      console.log(`updateStatus attempt ${retryCount + 1} for event: ${event_id}`);

      const data = await updateStatus({ event_id: event_id });
      if (data.error) {
        console.log(`updateStatus returned error on attempt ${retryCount + 1}:`, data.error);

        if (data.error.status === 500 || data.error.originalStatus === 500) {
          console.log("Server returned 500 error");
          if (retryCount < 2) {
            console.log(`Will retry 500 error (${retryCount + 1}/2)...`);
            await new Promise((resolve) => setTimeout(resolve, 1000));
            return handleUpdateExamStatus(event_id, retryCount + 1);
          }
          return false;
        }

        if (data.error.data?.error?.message === "UnAuthorized") {
          handleUnauthorized();
          return false;
        }
      }

      if (data.data) {
        if (data.data.error?.message === "UnAuthorized") {
          handleUnauthorized();
          return false;
        }

        return true;
      }

      if (retryCount < 2) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return handleUpdateExamStatus(event_id, retryCount + 1);
      }

      return false;
    } catch (error) {
      if (retryCount < 2) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return handleUpdateExamStatus(event_id, retryCount + 1);
      }

      return false;
    }
  };

  const handelSendAdvanceReportLSQ = async () => {
    if (!shouldShowAdvanceReport) return;

    if (!isBooked) {
      console.log("Advance report not available - exam not booked");
      return;
    }

    if (hasExternalAdvanceReport && externalReportRoute) {
      history.push(externalReportRoute);
    } else {
      setAdvanced(true);
    }
  };

  const handelAdvancedReport = async (examId, event) => {
    if (!shouldShowAdvanceReport) return;

    if (!isBooked) {
      console.log("Cannot fetch advance report - exam not booked");
      return;
    }

    try {
      const data = await fetchAdvancereport({ examId: examId, event: event });
      if (data?.data?.advanced_report.length > 0) {
        DetailedReportWebEngage();
        setAdvanceReport(data?.data?.advanced_report[0]);
        handelSendAdvanceReportLSQ();
      } else {
        setCondition("Notyet");
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setCondition("Notyet");
    }
  };

  const DetailedReportWebEngage = async () => {
    const call = false;
    if (call) {
      try {
        await webEngage({
          crn_id: `${examdetailes?.crn_id}`,
          event_name: "Detailed_Report_Generated_Inmobius",
          event_data: [
            { attribute: "test_name", value: `${examdetailes?.StudentExamType + " " + examdetailes?.level}` },
            { attribute: "test_type", value: `${examdetailes?.title}` },
            { attribute: "event_id", value: `${examdetailes?.event_id}` },
            {
              attribute: "CAR_report_basic_link",
              value: `${CONFIG_VARS.report_link}${currentExam}-report/${examdetailes?.crn_id}/${examdetailes?.event_id}`
            },
            { attribute: "Platform", value: "InMobius" },
            { attribute: "page_url", value: `/reports/${examId}` }
          ]
        });
      } catch (error) {
        console.error("Error pushing WebEngage event:", error);
      }
    }
  };

  useEffect(() => {
    const initializeReports = async () => {
      setReportLoader(true);
      console.log("Starting report initialization...");

      try {
        const updateStatusSuccess = await handleUpdateExamStatus(examdetailes.event_id);
        console.log("updateStatus final result:", updateStatusSuccess);

        if (updateStatusSuccess) {
          console.log("updateStatus successful, fetching reports...");

          // Fetch WebEngage submitted_at separately with retry logic
          fetchSubmittedAtForWebEngage();

          await Promise.all([
            handleFetchExamdetials(examId),
            handleFetchExamReport(examId),
            handleFetchExamStatus(examId, currentExam)
          ]);
          console.log("All reports fetched successfully");
        } else {
          console.log("updateStatus failed after 3 attempts. Keeping loader visible.");
        }
      } catch (error) {
        console.error("Error in initializeReports:", error);
      }
    };

    initializeReports();
  }, []);

  useEffect(() => {
    if (!isBooked) {
      setCondition("timer");
      return;
    }

    if (timeLeft > 0) {
      setCondition("almost");
      const timerId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timerId);
    } else if (timeLeft === 0) {
      setCondition("almost");
      if (shouldShowAdvanceReport) {
        handelAdvancedReport(examId, currentExam);
      }
    }
  }, [timeLeft, isBooked, shouldShowAdvanceReport]);

  useEffect(() => {
    if (timeLeft24 > 0 && isBooked) {
      const timerId = setInterval(() => {
        setTimeLeft24((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timerId);
    }
  }, [timeLeft24, isBooked]);

  useEffect(() => {
    if (timeLeft72 > 0 && isBooked) {
      const timerId = setInterval(() => {
        setTimeLeft72((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timerId);
    }
  }, [timeLeft72, isBooked]);

  useEffect(() => {
    if (timeLeft === 0 && !hasFetched && isBooked && shouldShowAdvanceReport) {
      setCondition("almost");
      handelAdvancedReport(examId, currentExam);
      setHasFetched(true);
    }
  }, [timeLeft, examId, currentExam, isBooked, shouldShowAdvanceReport]);

  const access_token = useSelector(getToken);
  const activeTimeLeft = timeLeft;

  const mainContainerClass = `Rep_main_cont${!shouldShowTalkToExpert ? " Rep_no_tte" : ""}`;

  return (
    <>
      <div className={mainContainerClass}>
        <BasicReport
          reportData={reportData}
          access_token={access_token}
          progressordata={progressordata}
          examDetails={examDetails}
          formetDate={formetDate}
          examdetailes={examdetailes}
          timeLeft24={timeLeft24}
          showBuyReportBanner={showBuyReportBanner}
          reportConfig={reportConfig}
          reportLoader={reportLoader}
          webEngageSubmittedAt={webEngageSubmittedAt}
          stickyBannerConfig={shouldShowTalkToExpert ? reportsPageStickyBannerConfig : null}
          onStickyBannerCta={() => openTalkToExpert("bottom_banner_tte")}
        />
        {!reportLoader && (
          <div>
            <div>
              {shouldShowTimer && !advanced && (
                <Timer
                  condition={condition}
                  timeLeft={activeTimeLeft}
                  openPopup={openPopup}
                  openpdf={openpdf}
                  examType={currentExam}
                  discount={false}
                  examId={examId}
                  onOpenTalkToExpert={openTalkToExpert}
                />
              )}
              {shouldShowAdvanceReport && advanced && (
                <AdvanceReport advanceReport={advanceReport} examdetailes={examdetailes} />
              )}
            </div>
          </div>
        )}
      </div>
      {redirectUrl && showPIP && (
        <PiPVideoPlayer
          src={`${CONFIG_VARS.pip_GCS_url}/pip-videos/Grade-${examdetailes.grade_id}.mp4`}
          redirectUrl={redirectUrl}
        />
      )}

      {showTalkToExpert && (
        <TalkToExpertModal
          isOpen={showTalkToExpert}
          onClose={() => setShowTalkToExpert(false)}
          source={talkToExpertSource}
        />
      )}
    </>
  );
};
